module.exports = __webpack_public_path__ + "static/img--ad--mail-e9642779b6e2a616ca7fa734d18cdf0e.png";